<template>
  <section id="hero">
    <v-img
      :min-height="minHeight"
      :src="require('@/assets/Homepage.jpg?v=123')"
      class="white--text"
      gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)"
    >
      <v-container class="fill-height px-4 py-12">
        <v-responsive
          class="d-flex align-center"
          height="60%"
          max-width="700"
          width="100%"
        >
          <base-heading title="Julibee Employment" />

          <base-body>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
            Consectetur adipiscing elit pellentesque habitant morbi tristique
            senectus et. Vitae suscipit tellus mauris a. Mollis aliquam ut
            porttitor leo a diam sollicitudin. Quisque non tellus orci ac auctor
            augue mauris. Blandit massa enim nec dui. Iaculis at erat
            pellentesque adipiscing. Feugiat nibh sed pulvinar proin gravida.
            Sagittis id consectetur purus ut faucibus pulvinar ele
          </base-body>

          <div
            :class="
              $vuetify.breakpoint.smAndDown
                ? 'flex-column align-start'
                : 'align-center'
            "
            class="d-flex flex-wrap"
          >
            <base-btn> Services </base-btn>

            <span class="font-weight-bold ml-6 mr-4 my-4">or</span>

            <base-btn :ripple="false" class="pa-1" height="auto" text>
              Contact us
            </base-btn>
          </div>
        </v-responsive>
      </v-container>
    </v-img>
  </section>
</template>

<script>
export default {
  name: "SectionHero",

  provide: {
    theme: { isDark: true }
  },

  computed: {
    minHeight() {
      const height = this.$vuetify.breakpoint.mdAndUp ? "100vh" : "50vh";

      return `calc(${height} - ${this.$vuetify.application.top}px)`;
    }
  }
};
</script>
